var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sedap-sustainable-practices-map" },
    [
      _c(
        "div",
        { staticClass: "sedap-sustainable-practices-map__table" },
        [
          !_vm.currentSP
            ? _c("PracticesTable", {
                attrs: {
                  tableData: _vm.sustainablePractices,
                  columns: _vm.columns,
                  onlyView: _vm.onlyView,
                  stripe: "",
                  title: "Vetorização de áreas com SPs"
                },
                on: { onAction: _vm.editSP }
              })
            : _c("VectorizationMenu", {
                ref: "vectorizationMenu",
                attrs: {
                  sp: _vm.currentSP,
                  drawnArea: _vm.drawnArea,
                  hasDrawing: _vm.hasDrawing
                },
                on: { onAction: _vm.handleVectorizationAction }
              })
        ],
        1
      ),
      _vm._v(" "),
      _c("BaseMap", {
        ref: "baseMap",
        attrs: { id: "sedap-map-georreferenciamento" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f180ff9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f180ff9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Maps/SustainablePracticesMap/SustainablePracticesMap.vue
// module id = null
// module chunks = 